
function openCandidateProModal() {
    var candidateModal = $("#candidateProModal");
    var wrapper = $("#candidateProModal .modal-wrapper");
    var route = $(wrapper).attr('data-route');
    $(candidateModal).modal('show').addClass('loading');
    wrapper.html('');
    if (route != "") {
        $.ajax({
            type: 'GET',
            url: route,
            contentType: "application/json",
            dataType: 'json',
            success: function(data) {
                if ((typeof data.result !== 'undefined') && (data.result == 1)) {
                    wrapper.html(data.form);
                }
                $(candidateModal).removeClass('loading');
                refreshCandidateModal();

            },
            error: function(e) {
                $(candidateModal).removeClass('loading');
            }
        });
    }
}

function refreshCandidateModal (){
    $('.js-advanced-select').select2();
}

function candidatePro() {
    $(document).ready(function () {
        $(document).on('click', '.btn--modal-candidate-pro', function(e) {
            e.preventDefault();
            openCandidateProModal();
            return false;
        });
    });
}

export default candidatePro;